export default "__VITE_ASSET__DypU16Sg__"